import { useEntity } from 'components';
import type { OutletOrServiceCategoryProduct } from './types';
import { ReactNode } from 'react';
import { Box, TableColumns } from '@ff-it/ui';
import { Link } from 'react-router-dom';
import { Icon } from 'components/Icon';
import { flexColumn } from 'components/ControlledTable';

function ProductOrInheritedCategory(product: OutletOrServiceCategoryProduct): ReactNode {
  const { item } = useEntity<OutletOrServiceCategoryProduct>();
  if (product.category) {
    return product.category.name;
  }
  if (item.category) {
    return (
      <Box color="gray500" title="Inherited from outlet or service category">
        <em>{item.category.name}</em>
      </Box>
    );
  }
  return null;
}

export const columns: TableColumns<OutletOrServiceCategoryProduct> = [
  {
    content: 'Type',
    key: 'type',
    sortable: true,
    width: 100,
  },
  flexColumn({
    content: 'Name',
    key: 'name',
    sortable: true,
    minWidth: 200,
    render: ({ id, name }) => <Link to={`${id}`}>{name || <em>Generic product</em>}</Link>,
  }),
  {
    content: 'Category',
    key: 'category.id',
    width: 250,
    render: (product: OutletOrServiceCategoryProduct) => <ProductOrInheritedCategory {...product} />,
  },
  {
    content: 'Kind',
    key: 'kind',
    sortable: true,
    width: 100,
  },
  {
    content: 'Unit',
    key: 'unit',
    width: 100,
  },
  {
    content: 'Direction',
    key: 'direction',
    width: 120,
  },
  {
    content: 'Application',
    key: 'application',
    width: 120,
  },
  {
    width: 110,
    content: 'Gross price',
    key: 'gross_price',
    cellProps: {
      textAlign: 'right',
    },
  },
  {
    width: 80,
    content: 'Enabled',
    key: 'disabled',
    cellProps: {
      textAlign: 'center',
    },
    render: ({ disabled }) => (
      <Icon className={!disabled ? 'text-success' : 'text-danger'} icon={!disabled ? 'check' : 'xmark'} />
    ),
  },
];
